(function() {

  function slider() {
    $('.slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      centerMode: true,
      prevArrow: '.slider__arrow-prev',
      nextArrow: '.slider__arrow-next',
      variableWidth: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            centerMode: false,
            variableWidth: false
          }
        },
      ]
    });
    
    $('.js-about-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      prevArrow: '.about__arrow-prev',
      nextArrow: '.about__arrow-next',
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            variableWidth: true
          }
        }
      ]
    });
    
  }

  function renderNews() {
    $.ajax({
      url: '/upload/news/list.json',
      dataType: 'json'
    })
      .then(
        function (data) {
          $('#box-1').find('.news__list').html(getNewsHtml(data['news']));
          $('#box-2').find('.news__list').html(getNewsHtml(data['press-release']));
        },
        function () {}
      );
  }

  function getNewsHtml(data) {
    let newsHtml = '';
    $.each(data, function(index, value) {
      if (index >= 3) {
        return false;
      }
      newsHtml += '<li class="news__list-item">';
      newsHtml += '<a href="/news/' + value.id +'/" class="news__link">';
      newsHtml += '<img src="/assets/img/common/orange-icon.svg" alt="" class="news__icon" />';
      newsHtml += '<p class="news__data">' + value.date +'</p>';
      newsHtml += '<p class="news__text">' + value.title +'</p>';
      newsHtml += '</a>';
      newsHtml += '</li>';
    })

    return newsHtml;
  }

  function newsTabSwitch() {
    $('.news__item').click(function() {
      $('.news__box').hide();
      $('#' + $(this).data('box')).show();
      $('.news__item').removeClass('is-current');
      $(this).addClass('is-current');
    })
  }
  
  function closeVide() {
    $('.youtube__btn,.youtube__overlay').click(function() {
      $(this).parents('.youtube').addClass('hide');
    })
  }

  function showYoutubeVideo() {
    var cookie = getCookie('show-yt');
    var player = $('.youtube__player');
    var videos = [
      'https://www.youtube.com/embed/O4mjjsV4HvM?autoplay=1&iv_load_policy=1&mute=1', 
      'https://www.youtube.com/embed/bkvTpPXn17E?autoplay=1&iv_load_policy=1&mute=1',
      'https://www.youtube.com/embed/6zJwwfJGLZI?autoplay=1&iv_load_policy=1&mute=1', 
      'https://www.youtube.com/embed/cnijwX1O5IY?autoplay=1&iv_load_policy=1&mute=1', 
      'https://www.youtube.com/embed/2gG9Ou3KvxY?autoplay=1&iv_load_policy=1&mute=1',
      'https://www.youtube.com/embed/M6-SH7F6sWg?autoplay=1&iv_load_policy=1&mute=1',
    ];
    if (!cookie) {
      showVideo();
    }
    
    // get random integer between min and max
    function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    
    function showVideo() {
      var videoIndex = getRandomInt(0, 5);
      player.attr('src', videos[videoIndex]);
      setCookie('show-yt', videoIndex, 7);   
      $('.youtube').removeClass('hide');
    }
  }


  const isPageTop = $('.top').length;
  if(isPageTop) {
    slider();
    renderNews();
    newsTabSwitch();
    closeVide();
    // showYoutubeVideo();
    getInstagram();
  }
})();